import { render, staticRenderFns } from "./ui-task-type-select.vue?vue&type=template&id=b6f0c160&"
import script from "./ui-task-type-select.vue?vue&type=script&lang=js&"
export * from "./ui-task-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports